module.exports = __webpack_public_path__ + "static/media/error-history.30eef311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/assets/img/error-history.svg
// module id = ./src/statsradio/assets/img/error-history.svg
// module chunks = 18